var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"block","font-family":"Figtree, sans-serif","background":"#fff"}},[(_vm.product.screen === 'one')?_c('AddProductFormOne'):(_vm.product.screen === 'two')?_c('AddProductFormTwo'):_c('AddProductsSuccess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }